<h2 mat-dialog-title>Debug Mode</h2>
<mat-dialog-content>
  @if (error.status) {
    <div style="height: 8%">
      <h2>{{ error.message }}</h2>
      <h4>{{ error.info }}</h4>
    </div>
  }
  <div style="display: flex; justify-content: center; align-items: center; height: 88%">
    <label
      for="fileDropRef"
      style="display: flex; align-items: center; gap: 8px; cursor: pointer; font-weight: bold; font-size: 16px"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="1em"
        height="10em"
        fill="#BB7C7AFF"
        style="flex-shrink: 0"
      >
        <path
          d="M440-280h80v-160h160v-80H520v-160h-80v160H280v80h160v160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"
        />
      </svg>
      Upload Json Payload
      <input
        style="display: none"
        type="file"
        #fileDropRef
        id="fileDropRef"
        (change)="onSubmit($event)"
        accept=".json"
      />
    </label>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
